<template>
  <div class="league" :style="{ top: league.top + 'px' }">
    <div class="league-hat">
      <favorite-toggler :active="favorite" type="league" :target="league.id" />
      <country-icon class="country-icon" v-if="league.country !== undefined" :code="league.country.code" :name="league.country.name" />
      <div class="league-name" v-if="league.country !== undefined">{{ league.name }}</div>
      <div class="league-name" v-if="league.country === undefined" :style="{ marginLeft: '33px' }">{{ league.name }}</div>
      <!--div class="factor-names-1 factor-names">
        <div class="factor-cell" v-for="(h, i) in sport.head[0]" :key="i">{{ h.name }}</div>
      </div-->
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import CountryIcon from '@/components/icons/CountryIcon'
import FavoriteToggler from '@/components/buttons/FavoriteToggler'

export default {
  components: { CountryIcon, FavoriteToggler },
  props: {
    favorite: Boolean,
    league: Object,
    sport: Object
  }
}
</script>

<style scoped>
.league { position: absolute; width: 100%; }
.league-hat { background: rgba(117,80,118,0.1) !important; display: flex; line-height: 40px; margin-right: 10px; marrgin-top: 5px !important; }
.league-hat:hover { background: rgba(117,80,118,0.1) !important; }
.country-icon { flex-shrink: 0; margin-left: -7px; margin-top: 1px; }
.league-name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 197px !important; flex: initial; }
.favorite-toggler { flex-shrink: 0; margin: 5px 5px 5px 5px; color:gray; }
.factor-names { display: none; flex: 1 1; margin-right: 10px; }
.factor-cell { align-self: center; flex-grow: 1; margin-left: 1px; text-align: center; }
</style>

<style>
.matches-list-group-1 .factor-names-1,
.matches-list-group-2 .factor-names-2,
.matches-list-group-1 .event .factors-1,
.matches-list-group-2 .event .factors-2 { display: flex; }
</style>



// WEBPACK FOOTER //
// src/components/sports/matches/League.vue